<!-- 资讯详情 -->
<template>
  <div v-cloak class="news_detail_root">
    <div class="detail_wrap">
      <div style="font-size: 28px" class="title bigSize">
        {{ newsDetail.title }}
      </div>

      <div v-if="hasMetaInfo" class="line" />
      <div class="subtitle">
        <span v-if="newsDetail.source_from">来源: {{ newsDetail.source_from }}</span>
        <span v-if="newsDetail.published_time">发布时间: {{ newsDetail.published_time }}</span>
        <span v-if="newsDetail.portalBrowseNum">阅读量: {{ newsDetail.portalBrowseNum }}</span>
        <span v-if="newsDetail.author">作者: {{ newsDetail.author }}</span>
      </div>
      <div v-if="hasMetaInfo" class="line" />
      
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
      </div>
      
      <!-- 错误信息 -->
      <div v-if="errorMsg" class="error-message">
        {{ errorMsg }}
      </div>
      
      <!-- 视频 -->
      <div v-if="newsDetail.videoPath" class="video-container">
        <video 
          :src="newsDetail.videoPath" 
          controls 
          class="video loading"
          @loadstart="onVideoLoadStart"
          @loadeddata="onVideoLoaded"
          @error="onVideoError"
        />
      </div>
      
      <!-- 文本 -->
      <div class="detail_news_content" v-html="newsDetail.content" />
    </div>
  </div>
</template>

<script>
import { getArticlesInfo } from "@/request/api";
import { ImagePreview } from 'vant';

export default {
  data() {
    return {
      newsDetail: {},
      loading: false,
      errorMsg: "",
      imageUrls: [] // 存储富文本中的所有图片URL
    };
  },

  computed: {
    hasMetaInfo() {
      return this.newsDetail.source_from || 
             this.newsDetail.author || 
             this.newsDetail.published_time;
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        document.title = "详情";
      },
    },
  },
  
  mounted() {
    // 将previewImage方法绑定到window对象，供HTML中的onclick调用
    window.previewImage = this.previewImage;
  },
  
  beforeDestroy() {
    // 清理window对象上的方法引用
    window.previewImage = null;
  },
  
  activated() {
    this.newsDetail = {};
    this.fetchDetailById(this.$route.query.newsId);
  },
  
  methods: {
    // 图片预览方法
    previewImage(index) {
      if (this.imageUrls.length === 0) return;
      
      ImagePreview({
        images: this.imageUrls,
        startPosition: index,
        onClose() {
          console.log('图片预览关闭');
        }
      });
    },
    
    // 视频加载开始
    onVideoLoadStart() {
      const videoElement = document.querySelector('.video');
      if (videoElement) {
        videoElement.classList.add('loading');
        videoElement.classList.remove('error');
      }
    },
    
    // 视频加载完成
    onVideoLoaded() {
      const videoElement = document.querySelector('.video');
      if (videoElement) {
        videoElement.classList.remove('loading');
        videoElement.classList.remove('error');
      }
    },
    
    // 视频加载错误
    onVideoError() {
      const videoElement = document.querySelector('.video');
      if (videoElement) {
        videoElement.classList.remove('loading');
        videoElement.classList.add('error');
      }
    },
    
    // 根据新闻 ID 获取详情
    fetchDetailById(id) {
      if (!id) return;
      
      this.loading = true;
      this.errorMsg = "";
      this.newsDetail = {};
      
      getArticlesInfo(id).then((res) => {
        this.loading = false;
        
        if (res.code !== 0) {
          this.errorMsg = res.msg || "获取详情失败";
          this.$Toast && this.$Toast.fail(res.msg);
          return;
        }
        
        // 处理HTML内容
        res.data.content = this.processHtmlContent(res.data.content);
        
        // 处理a标签
        this.processATags(res.data);
        
        this.newsDetail = res.data;
      }).catch(err => {
        this.loading = false;
        this.errorMsg = "获取详情失败，请稍后重试";
        console.error("获取详情失败", err);
      });
    },
    
    // 处理HTML实体
    processHtmlContent(content) {
      if (!content) return "";
      
      const replacements = [
        { pattern: /&lt;/g, replacement: "<" },
        { pattern: /&gt;/g, replacement: ">" },
        { pattern: /&quot;/g, replacement: '"' },
        { pattern: /&amp;nbsp;/g, replacement: " " },
        { pattern: /&amp;ldquo;/g, replacement: '"' },
        { pattern: /&amp;rdquo;/g, replacement: '"' }
      ];
      
      let processedContent = replacements.reduce((result, item) => {
        return result.replace(item.pattern, item.replacement);
      }, content);
      
      // 处理图片标签，添加懒加载和错误处理
      processedContent = this.processImages(processedContent);
      
      // 处理视频标签，移除固定尺寸属性，添加响应式样式
      processedContent = this.processVideos(processedContent);
      
      return processedContent;
    },
    
    // 处理图片标签
    processImages(content) {
      if (!content) return content;
      
      // 清空之前的图片URL数组
      this.imageUrls = [];
      
      // 匹配所有img标签
      const imgRegex = /<img([^>]*?)src=["']([^"']*?)["']([^>]*?)>/gi;
      
      return content.replace(imgRegex, (match, beforeSrc, src, afterSrc) => {
        // 处理图片URL
        let processedSrc = this.processImageUrl(src);
        
        // 将图片URL添加到数组中
        this.imageUrls.push(processedSrc);
        
        // 获取当前图片在数组中的索引
        const imageIndex = this.imageUrls.length - 1;
        
        // 添加懒加载属性
        const lazyAttributes = 'loading="lazy"';
        
        // 添加错误处理
        const errorHandler = 'onerror="this.classList.add(\'error\')"';
        
        // 添加加载状态
        const loadHandler = 'onload="this.classList.remove(\'loading\')"';
        
        // 添加初始加载状态类
        const loadingClass = 'class="loading"';
        
        // 添加点击事件，调用ImagePreview
        const clickHandler = `onclick="window.previewImage && window.previewImage(${imageIndex})"`;
        
        // 简化的图片容器结构
        return `<div class="image-container"><img${beforeSrc}src="${processedSrc}"${afterSrc} ${lazyAttributes} ${errorHandler} ${loadHandler} ${loadingClass} ${clickHandler}></div>`;
      });
    },
    
    // 处理视频标签
    processVideos(content) {
      if (!content) return content;
      
      // 匹配所有video标签
      const videoRegex = /<video([^>]*?)>/gi;
      
      return content.replace(videoRegex, (match, attributes) => {
        // 移除固定尺寸属性
        let processedAttributes = attributes
          .replace(/\s+width=["'][^"']*["']/gi, '')
          .replace(/\s+height=["'][^"']*["']/gi, '');
        
        // 添加响应式类名
        if (!processedAttributes.includes('class=')) {
          processedAttributes += ' class="rich-text-video"';
        } else {
          processedAttributes = processedAttributes.replace(
            /class=["']([^"']*?)["']/gi,
            'class="$1 rich-text-video"'
          );
        }
        
        // 包装在居中容器中
        return `<div class="rich-text-video-container"><video${processedAttributes}></video></div>`;
      });
    },
    
    // 处理图片URL
    processImageUrl(url) {
      if (!url) return url;
      
      // 如果是相对路径，转换为绝对路径
      if (url.startsWith('/') && !url.startsWith('//')) {
        // 获取API基础URL
        const baseUrl = process.env.VUE_APP_BASE_API || '';
        return baseUrl + url;
      }
      
      // 如果是协议相对路径，添加https协议
      if (url.startsWith('//')) {
        return 'https:' + url;
      }
      
      return url;
    },
    
    // 处理A标签
    processATags(data) {
      if (!data.content) return;
      
      const aTags = data.content.match(/<a.*?>.*?<\/a>/g);
      if (!aTags) return;
      
      let updatedContent = data.content;
      
      aTags.forEach((item) => {
        if (item.includes('href="http')) {
          const hrefMatch = item.match(/href="(.*?)"/);
          if (hrefMatch && hrefMatch[1] && hrefMatch[1].includes(".")) {
            const href = hrefMatch[1];
            const updatedTag = item.replace(
              /href="(.*?)"/,
              `href="${href}" target="_blank"`
            );
            updatedContent = updatedContent.replace(item, updatedTag);
          }
        }
      });
      
      data.content = updatedContent;
    }
  },
};
</script>

<style scoped lang="scss">
[v-cloak] {
  display: none;
}

// 视频容器样式
.video-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  width: 100%;
  
  .video {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    
    // 移动端优化
    @media (max-width: 768px) {
      max-width: 100%;
      max-height: 50vh;
    }
    
    // 小屏幕设备进一步优化
    @media (max-width: 480px) {
      max-height: 40vh;
    }
    
    &:focus {
      outline: none;
    }
    
    // 视频加载状态样式
    &.loading {
      background-color: #f5f5f5;
      min-height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      &::before {
        content: "视频加载中...";
        color: #999;
        font-size: 16px;
      }
    }
    
    // 视频加载失败样式
    &.error {
      background-color: #f5f5f5;
      min-height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed #ddd;
      
      &::before {
        content: "视频加载失败";
        color: #999;
        font-size: 16px;
      }
    }
  }
}

.news_detail_root {
  height: 100vh;
  width: 100%;

  .detail_wrap {
    height: 100%;
    background-color: #fff;
    padding: 30px;
    text-align: left;

    @media (min-width: 768px) {
      padding: 40px 40px;
    }

    .line {
      width: 100%;
      height: 1px;
      background: #e8e8e8;
      opacity: 1;
    }

    .title {
      font-size: 20px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 1.4;
      margin-bottom: 16px;
      
      @media (min-width: 768px) {
        font-size: 28px;
        line-height: 60px;
      }
    }

    .subtitle {
      font-size: 14px;
      color: #999999;
      line-height: 1.5;
      margin: 20px 0;
      
      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 36px;
        margin: 15px 0;
      }

      span {
        display: block;  // 移动端换行显示
        margin: 5px 0;
        
        @media (min-width: 768px) {
          display: inline;
          &:nth-child(2) {
            margin: 0 50px;
          }
        }
      }
    }
    
    .loading-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100px;
      width: 100%;
      
      .loading-spinner {
        width: 40px;
        height: 40px;
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        border-top-color: #09f;
        animation: spin 1s ease-in-out infinite;
      }
      
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    }
    
    .error-message {
      color: #f56c6c;
      text-align: center;
      padding: 20px;
      font-size: 16px;
    }

    .bigSize {
      font-size: 18px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
    }

    .subTitle {
      text-align: center;
      margin-bottom: 25px;
    }

    .detail_news_content {
      width: 100%;
      min-height: 100vh;
      text-align: left;
      text-indent: 20px;
      font-size: 28px;
      color: #333333;
      line-height: 50px;
      padding: 22px 10px 22px 10px;
      
      max-width: 100%;
      overflow-x: auto;
      word-wrap: break-word;
      word-break: break-word;

      ::v-deep .image-container {
        position: relative;
        display: block;
        margin: 10px auto;
        cursor: pointer;
      }
      
      ::v-deep img {
        // 响应式尺寸控制，避免图片被强制拉伸
        max-width: 100%;
        max-height: 50vh;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
        margin: 0 auto; // 修改为水平居中
        
        // 移动端优化
        @media (max-width: 768px) {
          max-height: 40vh;
        }
        
        // 小屏幕设备进一步优化
        @media (max-width: 480px) {
          max-height: 35vh;
        }
        
        // 添加图片加载状态样式
        &.loading {
          background-color: #f5f5f5;
          min-height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
          
          &::before {
            content: "图片加载中...";
            color: #999;
            font-size: 14px;
          }
        }
        
        // 图片加载失败样式
        &.error {
          background-color: #f5f5f5;
          min-height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px dashed #ddd;
          
          &::before {
            content: "图片加载失败";
            color: #999;
            font-size: 14px;
          }
        }
      }
    }
    
    // 富文本中的视频容器样式
    ::v-deep .rich-text-video-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0;
      width: 100%;
      
      .rich-text-video {
        max-width: 100% !important;
        height: auto !important;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        
        // 移动端优化
        @media (max-width: 768px) {
          max-width: 100% !important;
          max-height: 50vh !important;
        }
        
        // 小屏幕设备进一步优化
        @media (max-width: 480px) {
          max-height: 40vh !important;
        }
      }
    }
  }
}

::v-deep table {
  display: block;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;

  tr td {
    padding: 5px 10px;
    border: 1px solid #ddd;
  }
}

::v-deep a {
  font-size: 16px !important;
}
</style>